module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Arboldswil-d731f25b7a764465d35fbc6ac9d0b200.svg";